<template>
  <CCard>
    <CCardBody>
      <CCardHeader>
        <CRow>
          <CCol col="8" style="text-align: start">
            <strong>{{ $t('receiveChequeDoc') }}</strong>
          </CCol>
          <CCol col="4" style="text-align: end">
            <CButton v-if="status_form==0 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_cheque()"
                     type="submit"
                     size="sm" color="secondary">
              {{ $t('buttons.save') }}
            </CButton>

            <CButton v-if="status_form!=0 && !is_year_closed()" @click="insert_data_cheque()" type="submit" size="sm"
                     color="secondary">
              <CIcon name="cil-check-circle"/>
              {{ $t('buttons.editDoc') }}
            </CButton>
            <CButton v-if="status_form==0 && is_year_closed()" class="mr-1 ml-1"
                     @click="year_closed_dialog()"
                     size="sm"
                     color="danger">
              {{ $t('buttons.save') }}
            </CButton>
            <CButton v-if="status_form!=0  && is_year_closed()" class="mr-1 ml-1"
                     @click="year_closed_dialog()" type="submit"
                     size="sm"
                     color="danger">
              {{ $t('buttons.editDoc') }}
            </CButton>
            <CButton
                class="mr-1"
                size="sm"
                color="secondary"
            >{{ $t("buttons.print") }}
            </CButton>
            <CButton class="mr-1 ml-1" @click="empty_form()" type="submit" size="sm" color="secondary">
              {{ $t('buttons.cancel') }}
            </CButton>
            <a :href="$route.fullPath" target="_blank">
              <CButton
                  class="mr-1 ml-1"
                  size="sm"
                  color="dark"
              >
                <CIcon size="sm" name="cil-plus"></CIcon>
              </CButton>
            </a>
          </CCol>
        </CRow>
        <!--        </div>-->

        <!-- Right aligned nav items -->
        <!--      </CCollapse>-->
      </CCardHeader>

      <CRow>
        <CCol col="4">
          <CRow form class="form-group">
            <CCol tag="label" sm="4" class="col-form-label">
              {{ $t('components.payer') }}
            </CCol>
            <CCol sm="8">
              <CInput v-model="selected_payer_cash_text" />

            </CCol>
          </CRow>

        </CCol>

        <CCol col="4">
          <CRow form class="form-group">
            <CCol tag="label" sm="4" class="col-form-label">
              {{ $t('components.receiveDate') }}
            </CCol>
            <CCol sm="8">
              <date-picker
                  v-model="date_cheque"
                  :min="get_min_doc_date()"
                  :max="get_max_doc_date()"
              ></date-picker>

            </CCol>
          </CRow>

        </CCol>

      </CRow>


      <CRow>
        <CCol col="12">

          <CDataTableFixed
              :items="items_receive_cheque"
              :fields="fields_receive_cheque"
              border
              :items-per-page="200"
              hover
              height="300px"
              pagination
          >
            <template #row="{item,index}">

              <td style="text-align: center">
                <label>{{ index + 1 }}</label>
              </td>
            </template>
            <template #pay_for="{item}">
              <td>
                <CInput
                    :placeholder="$t('description')"
                    v-model="item.summary"
                />
              </td>
            </template>
            <template #reference="{item,index}">
              <td>
                <CRow>
                  <CCol col="10">
                    <treeselect
                        v-model="item.document_refrence"
                        appendToBody
                        valueFormat="object"
                        @open="focus_reference(item,index)"
                        :cacheOptions="false"

                        :async="true"
                        @select="select_refrence_cheque(item,index)"
                        :load-options="load_reference"
                        :placeholder="$t('search')"
                        :normalizer="normalizer_refrence"
                    />
                    <label v-if="item.invoice_remaining && item.document_refrence!=null">{{ $t('tables.balance') }} :
                      {{ get_currency(item.invoice_remaining) }}</label>

                  </CCol>
                  <CCol col="2" class="p-0 m-0">
                    <!--                    <CButton>-->
                    <CIcon v-if="item.document_refrence!=null"
                           @click.native="get_invoice_report(item.document_refrence)"
                           name="cil-magnifying-glass"/>
                    <!--                    </CButton>-->

                  </CCol>
                </CRow>

              </td>
            </template>
            <template #amount="{item}">
              <td>
                <CInputCurrency
                    v-on:keypress="isDecimal2($event,item.amount)"
                    v-model="item.amount"
                />
              </td>
            </template>
            <template #serial="{item}">
              <td>
                <CInput
                    type="number"
                    v-on:keypress="isNumber($event)"
                    v-model="item.serial"
                />
              </td>
            </template>
            <template #payer="{item,index}">
              <td>
                <CRow>
                  <CCol>
                    <CSelect
                        v-if="item.document_refrence== null"
                        :options="master_types"
                        @change="clear_tafsili_selected(item)"

                        :value.sync="item.selected_master_type"
                    />
                    <label v-else>{{ $t('factor') }}</label>

                  </CCol>
                  <CCol>
                    <treeselect
                        v-if="item.document_refrence== null"
                        v-model="item.selected_tafsili"
                        :options="item.tafsili_list"
                        appendToBody
                        @search-change="add_master_to_search(item)"
                        :async="true"
                        @select="get_person_remaining_amount(index,item,...arguments)"
                        valueFormat="object"

                        :load-options="load_tafsilis"
                        :cacheOptions="false"
                        :placeholder="$t('components.searchUser')"
                        :normalizer="normalizer_tafsili"
                    />
                    <label v-else>{{ item.document_person_name }}</label>
                    <br>
                    <label
                        v-if="item.remaining!=null && (item.document_refrence!= null || item.selected_tafsili!=null)"
                    >{{ $t('tables.balance') }} : {{ get_currency(item.remaining) }}</label>

                  </CCol>
                </CRow>
              </td>
            </template>
            <template #pass_date="{item}">
              <td>
                <date-picker
                    v-model="item.pass_date"

                ></date-picker>
              </td>
            </template>

            <template #bank2-header="{item}">
              <div>
                <label class="text-center">{{ $t('tables.bank') }}</label>

              </div>
              <div>
                <div style="width: 100%">
                  <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33.3%;border-bottom: 0">{{ $t('bankName') }}</label>
<!--                  <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33.3%;border-bottom: 0">{{ $t('sortCode') }}</label>-->
<!--                  <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33.3%;border-bottom: 0">{{ $t('AccountNo') }}</label>-->
                </div>
              </div>
              <!--                  <thead>-->

              <!--                  </thead>-->
            </template>

            <template #bank="{item}">
              <!--                  <thead>-->
              <tr>
                <td style="width: 33.3%;border-top: 0">
                  <CSelect style="margin-bottom: 1rem"
                           :options="bank_names"
                           :value.sync="item.bank_name"
                  />
                </td>
<!--                <td style=";border-top: 0">-->
<!--                  <CInput-->
<!--                      v-model="item.sort_code"-->
<!--                      :maxlength="6"-->
<!--                  />-->
<!--                </td>-->
<!--                <td style=";border-top: 0">-->
<!--                  <CInput-->
<!--                      :maxlength="8"-->
<!--                      v-model="item.bank_no"-->
<!--                  />-->
<!--                </td>-->
              </tr>
              <!--                  </thead>-->
            </template>
            <template #summary="{item}">
              <!--                  <thead>-->
<!--              <tr>-->
                <td style="width: 33.3%;border-top: 0">
                  <CInput style="margin-bottom: 1rem"
                           v-model="item.summary"
                  />
                </td>
<!--                <td style=";border-top: 0">-->
<!--                  <CInput-->
<!--                      v-model="item.sort_code"-->
<!--                      :maxlength="6"-->
<!--                  />-->
<!--                </td>-->
<!--                <td style=";border-top: 0">-->
<!--                  <CInput-->
<!--                      :maxlength="8"-->
<!--                      v-model="item.bank_no"-->
<!--                  />-->
<!--                </td>-->
<!--              </tr>-->
              <!--                  </thead>-->
            </template>

            <template #operation-header>
              <CButton
                  class="mr-1"
                  size="sm"
                  @click="items_receive_cheque.splice(0,0,{selected_master_type: 80})"
                  color="dark"
              >
                <CIcon size="sm" name="cil-plus"></CIcon>
              </CButton>

            </template>
            <template #operation="{item,index}">
              <td>
                <CButton v-if="items_receive_cheque.length>1"
                         class="mr-1"
                         size="sm"
                         @click="items_receive_cheque.splice(index,1)"
                         color="primary"
                >
                  <CIcon size="sm" name="cil-minus"></CIcon>
                </CButton>
              </td>

            </template>


          </CDataTableFixed>

        </CCol>
        <CCol style="float: right">
          {{ $t('totalSum') }} : {{ get_currency(cheque_total) }}
        </CCol>
      </CRow>


    </CCardBody>
    <CModal
        color="dark"
        size="lg"
        :show.sync="invoice_info"
    >
      <CDataTableFixed
          :items="items_invoice"
          :fields="fields_invoice"
          :items-per-page="200"
          hover

          border
          striped

      >
        <template #row="{item,index}">

          <td>
            <p class="text-center">{{ index + 1 }}</p>

          </td>

        </template>
        <template #docDate="{item}">

          <td>
            <p class="text-center">{{ get_date(item.docDate) }}</p>

          </td>

        </template>

        <template #balance="{item}">
          <td>
            <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
            <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
            <p class="text-right text-danger" v-if="item.balance<0">{{
                get_currency(Math.abs(item.balance))
              }}</p>
            <p class="text-right" v-else>{{ get_currency(item.balance) }}</p>

          </td>
        </template>

        <template #amount="{item}">
          <td>
            <p class="text-right">{{ get_currency(item.amount) }}</p>
          </td>
        </template>
        <template #amountNegetive="{item}">
          <td>
            <p class="text-right">{{ get_currency(item.amountNegetive) }}</p>
          </td>
        </template>
        <template #partyName="{item}">

          <td>
            <p>{{ item.partyName }}</p>

          </td>

        </template>
        <template #toziKonande="{item}">

          <td>
            <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

          </td>

        </template>
        <template #user="{item}">
          <td>
            <p>{{ item.createdBy }}</p>
          </td>
        </template>
        <template #masterCode="{item}">
          <td>
            <p class="text-center">{{ item.masterCode }}</p>
          </td>
        </template>


        <template #operation="{item}">
          <td>

            <CButton v-if="item.statusId ==0"

                     size="sm"
                     :title="$t('buttons.finalize')"
                     @click="Finalize(item)"
            >
              <CIcon name="cil-trash" class="text-danger"/>
            </CButton>


          </td>
        </template>

        <template #under-table>
          <CRow>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol>{{ $t('totalCirculation') }}</CCol>
            <CCol>{{ get_currency(calculate_items(items_invoice, 'amountNegetive')) }}</CCol>
            <CCol>{{ get_currency(calculate_items(items_invoice, 'amount')) }}</CCol>
            <CCol></CCol>

          </CRow>
          <CRow>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
            <CCol class="bg-dark text-danger" v-if="calculate_items(items_invoice,'amountNegetive')
                - calculate_items(items_invoice,'amount')<0">{{
                get_currency(Math.abs(calculate_items(items_invoice, 'amountNegetive')
                    - calculate_items(items_invoice, 'amount')))
              }}
            </CCol>
            <CCol class="bg-dark" v-else>{{
                get_currency(calculate_items(items_invoice, 'amountNegetive')
                    - calculate_items(items_invoice, 'amount'))
              }}
            </CCol>
            <CCol></CCol>

            <CCol></CCol>
          </CRow>

        </template>

      </CDataTableFixed>

      <template #footer>
        <CButton @click="invoice_info = false" color="danger">{{ $t('buttons.close') }}</CButton>
      </template>
    </CModal>

  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import Vue from "vue";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
export default {
  name: 'ReceiveOperation',

  components: {
    Treeselect,
    BTabs,
  },

  data() {
    var self = this;

    return {
      selected_focus_reference: null,
      invoice_info: false,
      search_master_type: null,

      items_invoice: [],

      fields_invoice: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
        {key: 'accNo', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},

        {key: 'amountNegetive', label: this.$t('bedehkar'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('bestankar'), _style: 'width:10%'},

        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},

      ],

      search_reference_master: 0,
      selected_doc_type: 2,
      selected_receiver_cash: 0,
      document_person_cash: null,
      searched_refrences: [],
      get_items: [1],
      master_id: null,
      master_types: [
        {value: 163, label: this.$t('Suppliers')},
        {value: 80, label: this.$t('Customers')},
        {value: 92, label: this.$t('persons')},
        {value: 91, label: this.$t('components.employee')},
        {value: 288, label: this.$t('collector')},

        {value: 0, label: this.$t('Other')},
      ],
      active_tab: 0,
      summary: '',
      cashiers: [],
      banks: [],
      terminals: [],
      selected_payer_cash: null,
      doc_types: [
        {value: 2, label: this.$t('components.cash')},
        {value: 6, label: this.$t('components.bank')},
        {value: 1, label: this.$t('components.pos')},
      ],
      status_form: 0,
      price: '',
      bank_names: [],
      searched_person: [],
      document_person: null,
      search_user_async: true,
      pay_for_detail: null,
      // search_detail_async



      normalizer_tafsili(node) {
        return {
          id: node.recId,
          label: node.recTitle,
        }
      },
      normalizer_refrence(node) {
        return {
          id: node.factorMasterId,
          label: node.masterCode,
        }
      },
      normalizer_documents(node) {
        return {
          id: node.id,
          label: node.label,
        }
      },
      items: [],
      selected_master_type_item: 0,

      tafsili_list: [],
      selected_tafsili: 0,
      date_cheque: "",
      selected_payer_cash_text: '',
      selected_receiver_cheque: null,
      summary_cheque: "",
      items_receive_cheque: [{selected_master_type: 80}],
      fields_receive_cheque: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:2%;padding:0px'},
        {key: 'payer', label: this.$t('tables.customer'), _style: 'width:23%;padding:0px'},


        {key: 'reference', label: this.$t('referenceNo'), _style: 'width:12%;padding:0px'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:9%;padding:0px'},

        // {key: 'pay_for', label: this.$t('tables.payFor'), _style: 'width:12%;padding:0px'},

        {key: 'pass_date', label: this.$t('components.passDate'), _style: 'width:12%;padding:0px'},
        {key: 'serial', label: this.$t('chequeNumber'), _style: 'width:8%;padding:0px'},
        {key: 'bank', label: this.$t('tables.bank'), _style: 'width:15%;padding:0px'},
        // {key: 'bank_name', label: "نام بانک", _style: 'width:10%;padding:0px'},
        // {key: 'sort_code', label: "سورت کد", _style: 'width:10%;padding:0px'},
        // {key: 'bank_number', label: "شماره حساب", _style: 'width:10%;padding:0px'},
        {key: 'summary', label:this.$t('tables.payFor'), _style: 'width:10%;padding:0px'},

        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:2%;padding:0px'},
      ],
    }
  },
  mounted() {
    // this.select_moein(this.items_receive_cheque[0],0)

    this.date_cheque = this.get_today();
    if (this.date_cheque > this.get_max_doc_date()) {
      this.date_cheque = this.get_max_doc_date()
    }
    if (this.date_cheque < this.get_min_doc_date()) {
      this.date_cheque = this.get_min_doc_date()
    }
    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
    this.get_banks();
    this.get_bank_names();
    this.get_cashiers();
    this.get_terminals();
    this.get_receive_list();
    bus.$on("update_add_receive", (data) => {
      // alert(data);
      this.get_receive_list();

    });

    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
    }
  }, watch: {
    '$route.params.product_id': function () {
      this.get_product_data();
    }
  },
  computed: {
    cheque_total() {
      var total = 0;
      this.items_receive_cheque.forEach((val) => {
        if (val.amount != null) {
          total += parseFloat(val.amount);

        }
      });
      return total;
    },

    payer_items() {
      var items = [];
      if (this.selected_doc_type == 2) {
        this.cashiers.forEach((val) => {
          var obj = {label: val.boxTitle, value: val.id}
          items.push(obj)
        });
      }
      if (this.selected_doc_type == 6) {
        this.banks.forEach((val) => {
          var obj = {label: val.bankAccTitle, value: val.id}
          items.push(obj)
        });
      }
      if (this.selected_doc_type == 1) {
        this.terminals.forEach((val) => {
          var obj = {label: val.terminalTitle, value: val.id}
          items.push(obj)
        });
      }
      if (items.length > 0) {
        this.selected_receiver_cash = items[0].value;
      }
      return items;
    },

    payfor_items() {
      var items = [];

      return items;
    },
  },
  methods: {
    clear_tafsili_selected(item) {
      console.log("clear tafsili")
      item.selected_tafsili = null
    },

    focus_reference(item, index) {
      this.selected_focus_reference = index
      this.selected_master_type_item = item.selected_master_type

      console.log('selec_reference', index)
    },
    empty_form() {
      this.items_receive_cheque = [{}];
      this.status_form = 0
    },

    select_moein(item, index) {
      var self = this;

      const formData = new FormData();
      var url = "GetAccTafsilisByAccountId";
      formData.append("accId", item.selected_master_type);
      // formData.append("accId", this.selected_master_type);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              // item.tafzili_list = response.data.data;
              // item.tafsili_list = response.data.data;
              Vue.set(item, "tafsili_list", response.data.data);
              if (item.tafsili_list.length > 0) {
                item.selected_tafsili = item.tafsili_list[0].value;

              } else {
                self.selected_tafsili = null;

              }
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },
    load_tafsilis({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();
          console.log("search called", this.search_reference_master)
          var url = "GetAccTafsilisByAccountId";
          formData.append("accId", this.search_master_type);
          formData.append('SearchTxt', searchQuery);

          axios.post(url, formData, {show_pros: false}).then(function (response) {
            options = response.data.data;

            callback(null, options);

            // localStorage.setItem("api_token", response.data.access_token);
            // self.$router.push({ path: 'notes' });
          })
              .catch(function (error) {
                console.log(error);
              });
        })
      }
    },

    select_refrence_cheque(item, index) {
      var self2 = this

      setTimeout(() => {
        // self2.items_receive_cash[index].document_person_name = this.searched_refrences.find(z => z.factorMasterId === item.document_refrence)
        Vue.set(self2.items_receive_cheque[index], "document_person_name", item.document_refrence.partyName);
        Vue.set(self2.items_receive_cheque[index], "document_person", item.document_refrence.partyId);
        self2.get_person_remaining_amount(index, item, {recId: item.document_refrence.partyId})
        self2.get_invoice_remaining(item, index);
      }, 300);

    },
// 222800 16 3 26 4
    load_reference({action, searchQuery, callback}) {
      var self2 = this;
      var id = self2.items_receive_cheque[self2.selected_focus_reference].selected_tafsili.recId
      // var id = self2.search_reference_master
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();
          console.log("id is " + id)
          if (id == null) {
            id = 0;
          }
          formData.append('Id', id);
          formData.append('SearchTxt', searchQuery);
          formData.append('TypeId', this.selected_master_type_item);

          axios.post('GetFactorsByPartyId', formData, {show_pros: true}).then(function (response) {
            // options = response.data.data;
            // self2.searched_refrences=response.data.data;
            console.log('tafsili is',)
            if (self2.items_receive_cheque[self2.selected_focus_reference].selected_tafsili != null) {
              var selected_tafsili_tmp = self2.items_receive_cheque[self2.selected_focus_reference].selected_tafsili.recId

              options = response.data.data.filter(x => x.partyId == selected_tafsili_tmp);
              self2.searched_refrences = response.data.data.filter(x => x.partyId == selected_tafsili_tmp);
            } else {
              options = response.data.data;
              self2.searched_refrences = response.data.data;
            }
            callback(null, options);

            // localStorage.setItem("api_token", response.data.access_token);
            // self.$router.push({ path: 'notes' });
          })
              .catch(function (error) {
                console.log(error);
              });
        })
      }
    },

    get_bank_names() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_names = [];
          self.bank_names = self.sort_array(
              self.bank_names, content_data.data,
              'id', 'bankTitle');

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_master_to_search(item) {
      console.log("search item search");
      this.search_reference_master = item.document_person
      this.search_master_type = item.selected_master_type

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];


      return true;
      // e.preventDefault();
    },


    insert_data_cheque() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddReceiverCheque";
      } else {
        url = "EditCashPayment";
        formData.append('id', this.status_form)

      }
      // var master = {
      //   PaymentTypeId: this.selected_doc_type, AccountTypeId: 1, CashierId: this.selected_receiver_cash,
      //   PayerId: this.selected_payer_cash, DocDate: this.date_cash
      // };

      var details = [];

      for (var i = 0; i < this.items_receive_cheque.length; i++) {
        if (
            this.items_receive_cheque[i].amount != "" &&
            this.items_receive_cheque[i].serial != "" &&
            this.items_receive_cheque[i].pass_date != "" &&
            this.items_receive_cheque[i].amount != null &&
            this.items_receive_cheque[i].amount != "0") {
          if (this.$i18n.locale!='fa' && this.items_receive_cheque[i].sort_code.length != 6) {
            this.$root.root_validate_errors.push("Sort Code is 6 Characters");
            return
          }
          if (this.$i18n.locale!='fa' && this.items_receive_cheque[i].bank_no.length != 8) {
            this.$root.root_validate_errors.push("Account Code is 8 Characters");
            return
          }
          var factor_master_id = 0;
          var party_id = null

          if (this.items_receive_cheque[i].document_person != null) {
            factor_master_id = this.items_receive_cheque[i].document_refrence.factorMasterId
            party_id = this.items_receive_cheque[i].document_person

          }else{
             party_id = this.items_receive_cheque[i].selected_tafsili.recId

          }
          var obj = {
            SarRecidDate: this.items_receive_cheque[i].pass_date,
            DocDate: this.date_cheque,
            PartyId: party_id,
            Summary: this.items_receive_cheque[i].summary,
            MasterId: factor_master_id,
            Price: this.items_receive_cheque[i].amount,
            Serial: this.items_receive_cheque[i].serial,
            BankId: this.items_receive_cheque[i].bank_name,
            SortCode: this.items_receive_cheque[i].sort_code,
            BankAccount: this.items_receive_cheque[i].bank_no,

            PayerId: this.selected_payer_cash_text,
            PartyAccountId: this.items_receive_cheque[i].selected_master_type,

            BranchId: 0,
            MasterType: this.items_receive_cheque[i].master_type,
          };
          if (obj.PartyAccountId == 0) {
            obj.PartyAccountId = this.items_receive_cheque[i].tafsili_list
                .filter(x => x.recId == this.items_receive_cheque[i].selected_tafsili.recId)[0].accountId
          }

          if (obj.BankId == null) {
            obj.BankId = this.bank_names[0].value;
          }
          if (obj.MasterType == null) {
            obj.MasterType = 1;
          }
          if (obj.MasterId == null) {
            obj.DocMasterId = 0;
          }
          details.push(obj)
        }
      }
      var send_obj = {Cheques: details}
      console.log(JSON.stringify(send_obj))
      formData.append('model', JSON.stringify(send_obj));

      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        if (res.data.statusCode == 0) {
          self.selected_payer_cash_text = "";
          self.items_receive_cheque = [{}];
          bus.$emit("update_add_receive", "");

          self.$root.modal_component.show_api_response_modals(res);

        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          self.$root.modal_component.show_api_response_modals(res);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_banks() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.banks = content_data.data;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_receive_list() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCashPaymentList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data.reverse()

          self.items = content_data.data.filter(item => parseFloat(item.amount) > 0);

          self.items = self.items.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers = content_data.data;
          self.selected_doc_type = 2;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_terminals() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.terminals = content_data.data;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_invoice_report(item) {

      var self = this;
      var formData = new FormData();

      var url = "GetPersonAccountsByFactorId";

      // formData.append("FromDate", self.get_day_before_today_in_day(365));
      // formData.append("ToDate", self.get_today());
      formData.append('FactorId', item.factorMasterId);
      // formData.append('FactorId', 3667);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_invoice = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          var last_balance = 0;
          self.items_invoice.forEach(function (val) {
            val.balance = last_balance + parseFloat(val.amount);
            if (parseFloat(val.amount) > 0) {
              val.amountNegetive = Math.abs(parseFloat(val.amount))
              val.amount = 0;
            } else {
              val.amount = Math.abs(parseFloat(val.amount))

              val.amountNegetive = 0
            }
            last_balance = val.balance;
          });
          self.invoice_info = true;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_invoice_remaining(item, index) {

      var self = this;
      var formData = new FormData();

      var url = "GetPersonAccountsByFactorId";

      // formData.append("FromDate", self.get_day_before_today_in_day(365));
      // formData.append("ToDate", self.get_today());
      formData.append('FactorId', item.document_refrence.factorMasterId);
      // formData.append('FactorId', 3667);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          var items_invoice1 = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          var last_balance = 0;
          items_invoice1.forEach(function (val) {
            val.balance = last_balance + parseFloat(val.amount);
            if (parseFloat(val.amount) > 0) {
              val.amountNegetive = Math.abs(parseFloat(val.amount))
              val.amount = 0;
            } else {
              val.amountNegetive = 0
              val.amount = Math.abs(parseFloat(val.amount))
            }
            last_balance = val.balance;
          });
          Vue.set(self.items_receive_cheque[index], "invoice_remaining", last_balance);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_person_remaining_amount(index2, item, e) {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
      var url = ""
      if ([80, 91, 92, 163].includes(item.selected_master_type)) {
        url = "GetLastPartyAccountByParam"

      } else {
        url = "GetPersonAccountsByPersonId_New"
      }
      if (item.selected_master_type == 80) {//customers
        formData.append('TafsiliType', 2);
      } else if (item.selected_master_type == 163) {//suppliers
        formData.append('TafsiliType', 3);
      } else if (item.selected_master_type == 70) {
        formData.append('TafsiliType', 6);
      } else if (item.selected_master_type == 288) {
        formData.append('TafsiliType', 7);
      } else {
        formData.append('TafsiliType', 5);
      }

      formData.append('id', 0);

      formData.append('PartyId', e.recId);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if ([80, 91, 92, 163].includes(item.selected_master_type)) {
            if(item.selected_master_type==163){
              response.data.data.balance = response.data.data.balance*-1
            }
            Vue.set(self.items_receive_cheque[index2], "remaining", response.data.data.balance);

          } else {
            var items1 = content_data.data.personAccountItems.map((item, row_id) => {
              return {...item, row_id}
            });
            items1.forEach(function (val, index) {
              if (index == 0) {
                val.reminingBefore = 0;
                if (val.natureId == 0 && self.items[index + 1] != null) {
                  val.natureId = self.items[index + 1].natureId;
                }
                // val.accBalance = val.accBalance
              } else {
                val.reminingBefore = self.items[index - 1].accBalance;

                if (val.natureId == 2) {
                  val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                  // val.accBalanceFinal =val.accBalance
                  if (val.amount > 0) {
                    val.amountNegetive = Math.abs(val.amount);
                    val.amount = 0;

                  } else {
                    val.amount = Math.abs(val.amount);
                    val.amountNegetive = 0;
                  }
                } else {

                  val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                  if (val.amount < 0) {
                    val.amountNegetive = 0;
                    val.amount = Math.abs(val.amount);

                  } else {
                    val.amountNegetive = Math.abs(val.amount);
                    val.amount = 0;

                  }
                }
              }

              Vue.set(self.items_receive_cheque[index], "remaining", items1[items1.length - 1].accBalance * -1);

              // item.remaining

            })

          }

          // response.data.data.balance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },



  }
}

</script>
